import type { StreamOutput } from '../api/generated';
import { plainText } from './executionText';

export interface TerminalOutputProps {
  readonly label: string;
  /** What the program wrote; absent when there is nothing (yet). */
  readonly output?: StreamOutput;
  /** Shown instead of output when there is none. */
  readonly placeholder?: string;
  /** Status lines after the output, e.g. how the program ended. */
  readonly footer?: readonly string[];
}

/** Program output in terminal style. Text only: output is never interpreted as markup. */
export function TerminalOutput({ label, output, placeholder = '(no output)', footer = [] }: TerminalOutputProps) {
  const empty = output === undefined || output.text === '';
  return (
    <div className="terminal-output" role="log" aria-label={label}>
      {empty ? <p className="terminal-muted">{placeholder}</p> : <pre>{plainText(output.text)}</pre>}
      {output?.truncated && <p className="terminal-status">── output truncated ──</p>}
      {footer.map((line) => (
        <p key={line} className="terminal-status">
          ── {line} ──
        </p>
      ))}
    </div>
  );
}
